module.exports = __webpack_public_path__ + "img/bb.a461bfef.png";